export const WEEPING = 'weeping'
export const QUIPPING = 'quipping'
export const PUZZLED = 'puzzled'
